/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
*
* Google CDN, Latest jQuery
* To use the default WordPress version of jQuery, go to lib/config.php and
* remove or comment out: add_theme_support('jquery-cdn');
* ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {//
            init: function() {
                // We search for the footer contact form
                var $contactoHomeForm = $("#ContactoHomeForm");
                var $contactField = $contactoHomeForm.find("#footerContact_contacto");

                if($contactoHomeForm.size() === 1) {        // Exists
                    var viewport = ResponsiveBootstrapToolkit;

                    var updateForm = function(){
                        if( viewport.is('sm') || viewport.is('xs') ) {   // If bootstrap resolution is 'xs', we change the client contact field to 'tel'
                            $contactField.attr('type', 'tel');
                            $contactField.attr('placeholder', 'Teléfono');
                        } else {
                            $contactField.attr('type', 'text');
                            $contactField.attr('placeholder', 'Teléfono/email');
                        }
                    }
                    updateForm();
                    
                    $(window).bind('resize', function() {
                        viewport.changed(updateForm);
                    });

                    // TODO: if @ detected, change type to 'email' (or not)
                }
            },
            finalize: function() {
                $("body").removeClass("preload");
            }
        },
        // Home page
        'home': {
            init: function() {
                Dvalza.Swipe.init();
            },
            finalize: function() {
            }
        },
        // About us page, note the change from about-us to about_us.
        'contacto': {
            init: function() {
                window.markers = [{
                    "title": "Dvalza Multiservicios",
                    "point": {"lat": 42.8565788, "lng": -2.6570877},
                    "content":  "<p><b>Dvalza Multiservicios</b></p>" +
                                "<p>687 066 004</p>" +
                                "<p>Oñate Kalea, 20 01013 VITORIA-GASTEIZ, ARABA</p>"



                }];

                var myOptions = {
                    zoom: 15,
                    center: new google.maps.LatLng(window.markers[0].point.lat, window.markers[0].point.lng),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    disableDefaultUI: true,
                    scrollwheel: false
                };

                window.map = new google.maps.Map(document.getElementById('map-canvas'), myOptions);

                var styles = [];

                styles.push({
                    featureType: "poi.business",
                    elementType: "labels",
                    stylers: [
                    {visibility: "off"}
                    ]
                });

                styles =  [{"featureType":"all","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"road","elementType":"all","stylers":[{"visibility":"on"},{"color":"#242424"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"},{"color":"#ffbf00"},{"weight":3.83}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"}]}];

                window.styledMap = new google.maps.StyledMapType(styles, {name: "Styled Map"});

                window.map.mapTypes.set('map_style', window.styledMap);
                window.map.setMapTypeId('map_style');

                window.infowindow = new google.maps.InfoWindow({
                    content: 'Placeholder'
                });

                var setPopupContent = function(){
                    console.log(this);
                    window.infowindow.setContent(this.html);
                    window.infowindow.open(window.map, this);
                };

                window.GoogleMarkers = [];

                for (var i = 0; i < window.markers.length; i++) {
                    var position = new google.maps.LatLng(window.markers[i].point.lat, window.markers[i].point.lng);
                    var marker = new google.maps.Marker({
                        position: position,
                        map: window.map,
                        title: window.markers[i].title,
                        html: window.markers[i].content,
                        animation: google.maps.Animation.DROP,
                    });

                    window.GoogleMarkers.push(marker);

                    google.maps.event.addListener(marker, 'click', setPopupContent);

                }

                google.maps.event.addListenerOnce(map, 'idle', mapResize);

                google.maps.event.addDomListener(window, "resize",mapResize);

                //$(window).resize(mapResize);
                
                function mapResize() {
                    latlng = window.GoogleMarkers[0].position;
                    map.setCenter(latlng);
                }

                mapResize();
            }
        },
        'multiservicio-24h ': {
            init: function(){},
            finalize: function(){}
        }
    };

    var Dvalza = {
        'Swipe': {

            init: function() {
                var elem = document.getElementById('home-slider');

                window.mySwipe = new Swipe(elem, {
                    // startSlide: 4,
                    auto: 3000,
                    //continuous: false,
                    //disableScroll: true,
                    // stopPropagation: true,
                    // callback: function(index, element) {},
                    transitionEnd: this.transitionEnd,
                });

                $("#home-slider ul.button-slider li a").click(function(e) {
                    e.preventDefault();
                    window.mySwipe.slide($(this).data("swipe-index"));
                });
            },

            transitionEnd: function(index, element) {
                $('.slider ul#slider-images li.selected').removeClass('selected').promise().done(function(){
                    $('.slider ul#slider-images li#slider-image-'+parseInt(index+1)).addClass('selected');
                });
                $('#home-slider ul.button-slider li a.selected').removeClass('selected');
                $('#home-slider ul.button-slider li a[data-swipe-index="'+index+'"]').addClass('selected');
                //this.swipe.getPos();
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
